<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <a class="close-btn cursor-pointer" (click)="close()"><i class="ri-close-fill"></i></a>
  </div>
  <mat-dialog-content>
    <div class="text-center">
      <form novalidate>
        <img src="../../../assets/images/change-status.svg" class="mb-4 m-auto d-table" alt="Change Status" />

        <h5 class="text-primary mb-2">Resolve Support Ticket</h5>
        
        <p class="fs-6 mb-3">
          Are you sure you want to mark ticket <span class="fw-bold text-white">{{ ticketId }}</span> as
          <span class="text-success fw-bold">Resolved</span>?
        </p>

        <div class="shift-info-card p-3 rounded mb-3 text-start" *ngIf="!isOtherCategory">
          <!-- Item & NFC Metadata Section -->
          <div class="metadata-box pb-3 mb-3 border-bottom-dark">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="field-label">SKU</span>
              <span class="field-value-highlight">{{ sku }}</span>
            </div>
            <div class="d-flex align-items-start justify-content-between gap-2" *ngIf="nfcCryptoId && nfcCryptoId !== 'N/A'">
              <span class="field-label">NFC ID</span>
              <span class="field-value-code text-end">{{ nfcCryptoId }}</span>
            </div>
          </div>

          <!-- Previously Allocated User Details -->
          <div *ngIf="hasAllocatedUser">
            <div class="user-box-label mb-2">PREVIOUSLY ALLOCATED USER DETAILS</div>
            <div class="allocated-user-box p-3 rounded mb-3">
              <div class="d-flex flex-column gap-2">
                <div class="d-flex align-items-center justify-content-between">
                  <span class="field-label">NAME</span>
                  <span class="field-value text-white fw-bold">{{ allocatedUserName }}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span class="field-label">EMAIL ID</span>
                  <span class="field-value text-info font-weight-medium">{{ allocatedUserEmail }}</span>
                </div>
              </div>
            </div>

            <div class="warning-alert-box p-3 rounded">
              <div class="d-flex align-items-start gap-2">
                <span class="warning-icon">⚠️</span>
                <div class="warning-text">
                  This NFC was previously allocated to <strong>{{ allocatedUserName }}</strong> ({{ allocatedUserEmail }}). Confirming this action will now <strong>remove the allocation (set to null)</strong> and trigger an email notification.
                </div>
              </div>
            </div>
          </div>

          <!-- If NFC is not currently allocated to any user -->
          <div *ngIf="!hasAllocatedUser">
            <div class="user-box-label mb-2">CURRENT ALLOCATION STATUS</div>
            <div class="allocated-user-box p-3 rounded mb-2 text-center">
              <span class="text-light-gray fs-7">No user is currently allocated to this NFC (Allocation is NULL).</span>
            </div>
            <p class="warning-text text-light-gray mb-0 fs-7">
              Confirming this action will mark the support ticket as resolved.
            </p>
          </div>
        </div>

        <div class="d-flex align-items-center mt-4 flex-wrap justify-content-center gap-3">
          <button matButton="filled" type="button" class="dialog-btn-secondary" (click)="close()">No, Cancel</button>
          <button matButton="filled" type="button" class="dialog-btn-primary" (click)="confirmResolution()">
            <span *ngIf="hasAllocatedUser && !isOtherCategory">Yes, Unallocate & Resolve</span>
            <span *ngIf="!hasAllocatedUser || isOtherCategory">Yes, Resolve Ticket</span>
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>


